import { render, staticRenderFns } from "./UnTablePage.vue?vue&type=template&id=6ce44403&scoped=true&"
import script from "./UnTablePage.vue?vue&type=script&lang=js&"
export * from "./UnTablePage.vue?vue&type=script&lang=js&"
import style0 from "./UnTablePage.vue?vue&type=style&index=0&id=6ce44403&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce44403",
  null
  
)

export default component.exports